if (!customElements.get('image-input')) {
    customElements.define(
      'image-input',
      class ImageInput extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector('input')
            this.bindEvents();
        }
  
        bindEvents() {
            this.input.addEventListener('input', this.onInputChange.bind(this))
        }
  
        onInputChange(event) {
            this.style.setProperty('--position', `${event.target.value / 10}%`)
        }
      }
    );
}

if (!customElements.get('image-input-controls')) {
  customElements.define(
    'image-input-controls',
    class ImageInputControls extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('button.image-inputs__controls-item')
        
        this.imagesList = this.closest('.clinical-results').querySelector('.image-inputs-list')
        this.imageInputs = this.imagesList.querySelectorAll('li.image-inputs__item')

        this.bindEvents();
      }

      bindEvents() {
        this.buttons.forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }

      onButtonClick(event) {
        event.preventDefault();

        let { imageIndex } = event.currentTarget.dataset

        this.imageInputs.forEach((el) => {
          let { inputIndex } = el.dataset
          if (inputIndex == imageIndex) {
            el.classList.add('active')
          } else {
            el.classList.remove('active')
          }
        })

        this.buttons.forEach((el) => {
          if (el == event.currentTarget) {
            el.classList.add('active')
          } else {
            el.classList.remove('active')
          }
        })
      }
    }
  );
}